/**
 * Founder-reported bug: clicking any image on a piece did nothing. Root
 * cause — Art Director (art-director.ts) generates "hero_cover" /
 * "social_twitter" / "social_linkedin", but ImagesPanel.tsx only recognized
 * the older "landscape" / "square" values (from before Art Director's
 * format naming changed), so every AI-generated image fell into the
 * non-clickable "Other" bucket. Both vocabularies are recognized here —
 * "landscape" and "square" still exist on ~290 older piece_images rows and
 * the manual upload widget still tags uploads "landscape".
 *
 * Pure function, kept out of ImagesPanel.tsx so it's unit-testable without
 * pulling in that component's Vite/Clerk-dependent imports.
 */

const FEATURED_FORMATS = new Set(["landscape", "hero_cover"]);
const SOCIAL_FORMATS = new Set(["square", "social_twitter", "social_linkedin"]);

/**
 * FEAT-102 / S-412 — Substack's press-kit images (`press_kit_instagram`,
 * `press_kit_square`, `press_kit_stories`), saved as piece images after a
 * Substack publish. Their own group: they are amplification images, never
 * the piece's featured image.
 */
const PRESS_KIT_PREFIX = "press_kit_";

export type ImageFormatGroup = "featured" | "social" | "press_kit" | "other";

export function classifyImageFormat(format: string | null | undefined): ImageFormatGroup {
  const f = format ?? "";
  if (f.startsWith(PRESS_KIT_PREFIX)) return "press_kit";
  if (FEATURED_FORMATS.has(f)) return "featured";
  if (SOCIAL_FORMATS.has(f)) return "social";
  return "other";
}
